<div [formGroup]="campaignForm" class="has-validation">
  <label class="form-label">
    {{ 'field.vatId' | translate }}
  </label>
  <input type="text" class="form-control" id="vatId" formControlName="vatId"  [ngClass]="{ 'is-invalid': campaignForm.get('vatId')?.invalid}" />
  <div class="invalid-feedback" translate="field.required"></div>
</div>
